export default {
    //国际化配置
    Config: {
        env: 'zh',//语言
        system: '中联数据资产管理',//中联数据资产管理
        Confirm: '确 认',
        Cancel: '取 消',
    },
}



// WEBPACK FOOTER //
// ./src/components/lang/zh.js